import axios from 'axios';
import Vue from 'vue';
import TabManager from '../general/tabmanager';
import DetailTab from './detailtab';
import PickupDetailTab from './pickupdetailtab';
import EstimationsTab from './estimationstab';
import InventoryTab from './inventorytab';
import BackofficeTab from './backofficetab';

export default Vue.component('servicepointedit', {
    extends: TabManager,
    components: {
        'detail': DetailTab,
        'pickupdetail': PickupDetailTab,
        'estimations': EstimationsTab,
        'inventory': InventoryTab,
        'backoffice': BackofficeTab
    },
    props:{
        pageMode: Number,
        servicePointId: String
    },
    data: function(){
        return {
            axe: axios.create({
                baseURL: '/mywecycle/servicepoint'
            }),
            tabs:[],
            currentTab: undefined,
            resources: {
                previousButtonText: 'Prev',
                saveButtonText: 'Save',
                nextButtonText: 'Next'
            }            
        }
    },
    methods:{
        /** set service point id if on create mode */
        onServicePointCreate(servicePointId){
            if(this.pageMode === 0){
                this.servicePointId = servicePointId;
            }
        },
        submitTab(){
            this.$refs.activeTabComponent.saveTab();
        }
    },
    mounted(){
        
    },
    created() {
        this.axe
            .get('/editdata', { params: { servicePointId: this.servicePointId }})
            .then((response) => {
                this.tabs = response.data.tabs;
                this.resources = response.data.resources;
                this.currentTab = this.getActiveTab();
            })
            .catch((error) => { console.log('Error retrieving page data : ' + error); });
    }
});